import {ClientNotesRecord} from "../../../models/ClientNotesRecord";
import {IsoDateTime} from "../../../../../pseudo-types/DateTypes";

export type ClientNotesViewModels = ReadonlyArray<ClientNotesViewModel>;

export class ClientNotesViewModel implements ClientNotesRecord {

    private _editing = false;

    private constructor(private readonly record: ClientNotesRecord) {
    }

    public get id(): number {
        return this.record.id;
    }

    public get accountId(): number {
        return this.record.accountId;
    }

    public get at(): IsoDateTime {
        return this.record.at;
    }

    public get by(): string {
        return this.record.by;
    }

    public get content(): string {
        return this.record.content;
    }

    public get noteTag(): string {
        return this.record.noteTag;
    }

    public get deleted(): boolean {
        return this.record.deleted;
    }

    public get edited(): boolean {
        return this.record.edited;
    }

    public get editing(): boolean {
        return this._editing;
    }

    public set editing(editing: boolean) {
        this._editing = editing;
    }

    public static of(record: ClientNotesRecord): ClientNotesViewModel {
        return new ClientNotesViewModel(record);
    }
}
